// styles
import { useSoFormStepsState } from 'refactored/features/soForm/SoForm.context';
import styled from 'styled-components';
import SoFormCandidateBlockDetails from './SoFormCandidateBlockDetails';
import SoFormCandidateBlockSummary from './SoFormCandidateBlockSummary';

const SoFormCandidateBlock = ({ candidate, className }) => {
  const stepsState = useSoFormStepsState();
  const selectedProductType = stepsState.price.selectedProductType;
  const isSelected = candidate.productType === selectedProductType;
  return (
    <div className={className}>
      <SoFormCandidateBlockSummary
        candidate={candidate}
        isSelected={isSelected}
      />
      {isSelected && <SoFormCandidateBlockDetails candidate={candidate} />}
    </div>
  );
};

export default styled(SoFormCandidateBlock)`
  width: 100%;
`;
